var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.values),function(item,index){return _c('p',{key:index},[_c('span',{staticClass:"main",style:(_vm.fontColor(index))},[_vm._v(_vm._s(item))]),_c('br'),_c('span',[_vm._v(_vm._s(_vm.secondValues[index]))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }